export const CODE_EDITOR_LANGUAGES = {
  typescript: 'typescript',
  javascript: 'javascript',
  css: 'css',
  json: 'json',
  html: 'html',
  xml: 'xml',
  markdown: 'markdown',
} as const;
